import styled from 'styled-components';
import { baseLinkStyles } from './Link';

export default styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  ${baseLinkStyles}
`;
